const UNITS = ['B', 'KB', 'MB', 'GB'] as const;

/** 1536 → "1.5 KB". Binary steps, one decimal above bytes. */
export function formatBytes(bytes: number): string {
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${unit === 0 ? value : value.toFixed(1)} ${UNITS[unit] ?? 'B'}`;
}
